export const MAX_REPETITION_DATES = 12;